import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-notification-details',
  templateUrl: './view-notification-details.component.html',
  styleUrls: ['./view-notification-details.component.scss']
})
export class ViewNotificationDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
